import React from "react";
import { Box, Typography } from "@mui/material";
import ShopGroupAccordion from "./ShopGroupAccordion";
import ServiceItem from "./ServiceItem";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

const DrawerSection = ({
  label,
  groups,
  isServices,
  expandedGroup,
  onToggle,
  onItemClick,
}) => {
  const getIcon = () => {
    if (label === "Shop")
      return (
        <LocalMallOutlinedIcon fontSize="small" sx={{ color: "#FD7762" }} />
      );
    if (label === "Services")
      return <ListAltOutlinedIcon fontSize="small" sx={{ color: "#FD7762" }} />;
    if (label === "Account")
      return (
        <PersonOutlineOutlinedIcon fontSize="small" sx={{ color: "#FD7762" }} />
      );
    return null;
  };

  return (
    <Box sx={{ mb: 2, px: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 1,
        }}>
        <Box sx={{ width: 24, display: "flex", justifyContent: "center" }}>
          {getIcon()}
        </Box>
        <Typography
          variant="subtitle2"
          sx={{
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "0.95rem",
            letterSpacing: 0.5,
            color: "#FD7762",
            ml: 1,
          }}>
          {label}
        </Typography>
      </Box>

      {isServices
        ? groups.map((group) => {
            const item = group.items?.[0];
            return (
              <ServiceItem
                key={group.label}
                label={group.label}
                isActive={item?.isActive}
                isLaunched={group.newLaunch}
                path={item?.path}
                onClick={onItemClick}
              />
            );
          })
        : groups.map((group) => (
            <ShopGroupAccordion
              key={group.label}
              group={group}
              expanded={expandedGroup === group.label}
              onToggle={() => onToggle(group.label)}
              onItemClick={onItemClick}
            />
          ))}
    </Box>
  );
};

export default DrawerSection;
